const formatNumber = (number: string | number) => {
  return Intl.NumberFormat('en-ZA').format(+number);
};

export default formatNumber;
